<template>
  <v-container style="max-width: 500px">
    <v-overlay
      absolute
      opacity="0.4"
      :value="loader"
    >
      <v-progress-circular indeterminate></v-progress-circular>
    </v-overlay>
    <v-form 
    ref="form" 
    @input="validateForm"
    v-model="formValid">
      <v-text-field
        class="mb-5"
        id="orgname"
        autocomplete="chrome-off"
        v-model="organisationName"
        :rules="rules.required"
        label="Organisation name"
      ></v-text-field>


      <v-row>
        <v-spacer></v-spacer>
        <v-btn @click="$emit('orgCreated')" text class="mr-2">Cancel</v-btn>
        
        <v-btn 
        @click="createOrganisation" 
        color="success">Create organiation</v-btn>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
  export default {
    data() {
      return {
        loader: false,
        formValid: false,
        organisationName: null,
        rules: {
          required:[ v => !!v || 'required'],
        }
      }
    },
    methods: {
      async createOrganisation() {
        this.loader = true
        try {
          await this.$store.dispatch("createOrganisation", {organisationName: this.organisationName})
          await this.$store.dispatch("getOrganisation")
          this.$router.push({name: "Home"})
          this.$emit("orgCreated", true)
        } finally {
          this.loader = false
        }
      },
      validateForm() {
        try {
          this.$refs.form.validate()
          
        } catch(e) {}
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>